module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/gacha_3-b9cdc437cc4b1a0e5ac82933d1a80dfe.png";